import * as React from "react";
function SvgQuestion(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-.794-12.735C11.09 9.405 11 9.65 11 10H9c0-.649.16-1.404.67-2.015C10.204 7.342 11.01 7 12 7s1.795.342 2.33.985c.51.61.67 1.366.67 2.015 0 1.376-.726 2.368-1.34 2.966-.236.231-.47.416-.66.555V14h-2v-.919a1.003 1.003 0 01.303-.805l.001-.001a1.696 1.696 0 01.203-.157l.004-.002.043-.029c.045-.029.092-.059.152-.1.154-.105.357-.257.558-.453.412-.402.736-.91.736-1.534 0-.351-.09-.596-.206-.735C12.705 9.158 12.51 9 12 9c-.51 0-.705.158-.794.265zM13 17v-2h-2v2h2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgQuestion);
export default ForwardRef;
